'use strict';
import omit from 'lodash/omit';
import {FilterDialogController} from '../../core-utilities/filters/FilterDialogController';


export class DateFilterDialogController extends FilterDialogController {
  static $inject = FilterDialogController.$inject;

  constructor(...args) {
    super(...args);

    this.vm.handleAfterDateChange = this.handleUseDateChange('afterDate').bind(this);
    this.vm.handleBeforeDateChange = this.handleUseDateChange('beforeDate').bind(this);
  }

  /**
   * Only include the date property when useDate is true.
   * This greatly simplifies the comparison logic, since useDate filters are always off by default.
   *
   * @param {String} type
   * @return {function(*)}
   */
  handleUseDateChange(type) {
    return value => {
      const filterOptions = this.vm.filterOptions;
      this.vm.filterOptions = {
        ...filterOptions,
        dateRange: value
          ? {
            ...filterOptions.dateRange,
            [type]: new Date(),
          }
          : omit(filterOptions.dateRange, [type]),
      };
    };
  }
}



// WEBPACK FOOTER //
// ./src/js/priorities/filters/DateFilterDialogController.js